/* SEKACAMP PDP - section-scoped, Theme-Editor-safe (re-inits on shopify:section:load) */
(function () {
  function initPdp(root) {
    if (!root || root.__sekaInit) return;
    root.__sekaInit = true;
    var scope = root.closest('.shopify-section') || document;

    var variants = [];
    var dataEl = scope.querySelector('[data-variants]');
    try { variants = JSON.parse((dataEl && dataEl.textContent) || '[]'); } catch (e) {}
    var invMap = {};
    var invEl = scope.querySelector('[data-inventory]');
    try { invMap = JSON.parse((invEl && invEl.textContent) || '{}'); } catch (e) {}

    var ISO = root.getAttribute('data-currency') || 'JPY';
    var locale = root.getAttribute('data-locale') || document.documentElement.lang || undefined;
    var addUrl = root.getAttribute('data-add-url') || '/cart/add.js';
    var labelAdded = root.getAttribute('data-label-added') || '';
    var labelError = root.getAttribute('data-label-error') || '';

    var selected = {};
    root.querySelectorAll('[data-opt-group]').forEach(function (g) {
      var on = g.querySelector('.opt-color.on');
      if (on) selected[on.getAttribute('data-opt-pos')] = on.getAttribute('data-opt-val');
    });

    var idInput = root.querySelector('[data-variant-id]');
    var nowEl = root.querySelector('[data-now]');
    var wasEl = root.querySelector('[data-was]');
    var atcText = root.querySelector('[data-atc-text]');
    var atcBtn = root.querySelector('[data-atc]');
    var labelAdd = (atcBtn && atcBtn.getAttribute('data-label-add')) || (atcText && atcText.textContent) || '';
    var labelSold = (atcBtn && atcBtn.getAttribute('data-label-sold')) || '';
    var mainImg = scope.querySelector('#pdp-main-img');
    var stickyPrice = scope.querySelector('[data-sticky-price]');
    var lowstockEl = root.querySelector('[data-lowstock]');
    var lowstockText = root.querySelector('[data-lowstock-text]');
    var lowstockFill = root.querySelector('[data-lowstock-fill]');
    var q = 1;
    var swapTimer = null;
    var firstPaint = true;
    function swapMain(url) {
      if (!mainImg || !url || mainImg.getAttribute('src') === url) return;
      clearTimeout(swapTimer);
      mainImg.style.opacity = '0';
      swapTimer = setTimeout(function () {
        mainImg.src = url;
        var show = function () { mainImg.style.opacity = '1'; };
        if (mainImg.complete && mainImg.naturalWidth > 0) requestAnimationFrame(show);
        else mainImg.onload = show;
      }, 240);
    }

    function money(cents) {
      var value = cents / 100;
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency: ISO, currencyDisplay: 'narrowSymbol' }).format(value); }
      catch (e) { return ISO + ' ' + value.toLocaleString(locale); }
    }
    function match() {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return selected[i + 1] === val; });
      });
    }
    function update() {
      var v = match();
      if (!v) {
        // no variant exists for this option combination - block add-to-cart with stale data
        if (atcBtn) atcBtn.disabled = true;
        if (atcText) atcText.textContent = labelSold;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (nowEl) nowEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (wasEl) {
        if (v.compare_at_price > v.price) { wasEl.textContent = money(v.compare_at_price); wasEl.removeAttribute('hidden'); }
        else { wasEl.setAttribute('hidden', ''); }
      }
      if (atcBtn) atcBtn.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? labelAdd : labelSold;
      if (v.featured_image && mainImg && !firstPaint) swapMain(v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_1100x$1$2'));
      if (lowstockEl) {
        var thr = parseInt(lowstockEl.getAttribute('data-threshold'), 10) || 100;
        var qty = invMap[v.id]; if (typeof qty !== 'number') qty = null;
        if (qty !== null && qty > 0 && qty <= thr) {
          var tmpl = lowstockEl.getAttribute('data-tmpl') || '????? {count} ?';
          if (lowstockText) lowstockText.textContent = tmpl.replace('{count}', qty);
          if (lowstockFill) lowstockFill.style.width = Math.min(95, Math.max(58, 100 - Math.round(qty / thr * 100))) + '%';
          lowstockEl.removeAttribute('hidden');
        } else { lowstockEl.setAttribute('hidden', ''); }
      }
    }

    root.querySelectorAll('[data-opt-val]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-opt-pos'), val = btn.getAttribute('data-opt-val');
        selected[pos] = val;
        root.querySelectorAll('[data-opt-pos="' + pos + '"]').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        var sel = root.querySelector('[data-opt-sel="' + pos + '"]'); if (sel) sel.textContent = val;
        update();
      });
    });

    var qv = root.querySelector('[data-qty-v]'), qi = root.querySelector('[data-qty-input]');
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () { q = Math.max(1, q + parseInt(b.getAttribute('data-qty'), 10)); if (qv) qv.textContent = q; if (qi) qi.value = q; });
    });

    root.querySelectorAll('.pdp-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        swapMain(t.getAttribute('data-thumb'));
        root.querySelectorAll('.pdp-thumb').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
      });
    });

    /* main-image lightbox - click to inspect full-screen */
    if (mainImg) {
      var lb = document.querySelector('.pdp-lightbox');
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'pdp-lightbox';
        lb.setAttribute('aria-hidden', 'true');
        lb.innerHTML = '<img alt=""><button type="button" class="lb-close" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg></button>';
        document.body.appendChild(lb);
        var lbClose = function () { lb.classList.remove('show'); lb.setAttribute('aria-hidden', 'true'); };
        lb.addEventListener('click', lbClose);
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lbClose(); });
      }
      mainImg.addEventListener('click', function () {
        var src = mainImg.currentSrc || mainImg.src; if (!src) return;
        lb.querySelector('img').src = src
          .replace(/_(\d+)x(?=\.[a-z]+)/i, '_2048x')
          .replace(/([?&]width=)\d+/i, '$12048');
        lb.classList.add('show');
        lb.setAttribute('aria-hidden', 'false');
      });
    }

    var sticky = scope.querySelector('[data-sticky]'), atcRow = root.querySelector('.atc-row');
    if (sticky && atcRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        sticky.classList.toggle('show', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(atcRow);
    }

    var toast = scope.querySelector('[data-toast]');
    function showToast(msg) {
      if (!toast) return;
      var t = toast.querySelector('[data-toast-text]'); if (t) t.textContent = msg;
      toast.classList.add('show'); setTimeout(function () { toast.classList.remove('show'); }, 2200);
    }
    function pickVariant() {
      var v = match();
      if (!v && idInput && idInput.value) v = variants.find(function (x) { return String(x.id) === String(idInput.value); });
      return v || variants[0] || null;
    }
    function add(v) {
      v = v || pickVariant(); if (!v) return;
      if (atcBtn) atcBtn.disabled = true;
      fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: q }) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function () { if (window.SekaCart && window.SekaCart.open) { window.SekaCart.open(); } else { showToast(labelAdded); } })
        .catch(function () { showToast(labelError); })
        .finally(function () { if (atcBtn) atcBtn.disabled = false; });
    }
    var form = scope.querySelector('#pdp-form');
    if (form) form.addEventListener('submit', function (e) {
      // let dynamic-checkout / non-"add" submitters use their own flow
      if (e.submitter && e.submitter.getAttribute('name') && e.submitter.getAttribute('name') !== 'add') return;
      var v = pickVariant();
      if (v && idInput) idInput.value = v.id; // keep the form's id correct for any path
      // ajax add when we can; otherwise allow the native browser submit (Shopify adds it server-side)
      if (v && window.fetch) { e.preventDefault(); add(v); }
    });
    var sa = scope.querySelector('[data-sticky-add]'); if (sa) sa.addEventListener('click', function () { add(); });

    var cdEl = root.querySelector('[data-countdown]');
    if (cdEl) {
      var cdMins = parseInt(cdEl.getAttribute('data-countdown'), 10) || 15;
      var CDKEY = 'seka_cd_deadline';
      var cdDeadline = function () {
        var d = parseInt(localStorage.getItem(CDKEY), 10);
        if (!d || d < Date.now()) { d = Date.now() + cdMins * 60000; try { localStorage.setItem(CDKEY, d); } catch (e) {} }
        return d;
      };
      var dl = cdDeadline();
      var cdTick = function () {
        var ms = dl - Date.now();
        if (ms <= 0) { dl = Date.now() + cdMins * 60000; try { localStorage.setItem(CDKEY, dl); } catch (e) {} ms = cdMins * 60000; }
        var s = Math.floor(ms / 1000), mm = Math.floor(s / 60), ss = s % 60;
        cdEl.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
      };
      cdTick();
      // keep the interval handle off the section element - the element is replaced
      // on shopify:section:load and the old timer would leak
      if (window.__sekaCdTimer) clearInterval(window.__sekaCdTimer);
      window.__sekaCdTimer = setInterval(cdTick, 1000);
    }

    update();
    firstPaint = false;
  }

  function initAll() { document.querySelectorAll('[data-pdp]').forEach(initPdp); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = null;
    if (e.target.matches && e.target.matches('[data-pdp]')) r = e.target;
    else if (e.target.querySelector) r = e.target.querySelector('[data-pdp]');
    if (r) { r.__sekaInit = false; initPdp(r); }
  });
})();
